module.exports = __webpack_public_path__ + "assets/img/6a8b3abfe32e0278c46d206b955bee1a.png";